var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('terms-detail-link',{attrs:{"detailLayout":_vm.detailLayout,"termsData":_vm.termsData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }